<div [formGroup]="formGroup">
  <div>
    <mat-form-field>
      <input id="udflytterNavn" matInput placeholder="Navn" aria-label="Navn" formControlName="navn" aria-required="true" required />
      @if (formGroup.controls.navn.hasError('required')) {
        <mat-error> Udfyld venligst feltet. </mat-error>
      }
    </mat-form-field>
  </div>
  <div formGroupName="adresse">
    <div>
      <mat-form-field>
        <input
          id="udflytterAdresse"
          matInput
          placeholder="Adresse"
          aria-label="Adresse"
          formControlName="vejnavn"
          aria-required="true"
          required
          />
          @if (formGroup.controls.adresse.get('vejnavn').hasError('maxlength')) {
            <mat-error> Adressen er for lang. </mat-error>
          }
          @if (formGroup.controls.adresse.get('vejnavn').hasError('required')) {
            <mat-error> Udfyld venligst feltet. </mat-error>
          }
        </mat-form-field>
      </div>
      <div>
        <mat-form-field>
          <input
            id="udflytterPostnr"
            matInput
            placeholder="Postnr."
            aria-label="Post Nummer"
            formControlName="postnr"
            aria-required="true"
            required
            />
            @if (formGroup.controls.adresse.get('postnr').hasError('pattern')) {
              <mat-error> Postnr. skal bestå af 4 tal. </mat-error>
            }
            @if (formGroup.controls.adresse.get('postnr').hasError('required')) {
              <mat-error> Udfyld venligst feltet. </mat-error>
            }
          </mat-form-field>
        </div>
        <div>
          <mat-form-field>
            <input id="udflytterBy" matInput placeholder="By" aria-label="By" formControlName="by" aria-required="true" required />
            @if (formGroup.controls.adresse.get('by').hasError('required')) {
              <mat-error> Udfyld venligst feltet. </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div>
        <dff-date-field
          id="flytdato"
          [formControl]="formGroup.controls.datoForUdflytning"
          placeholder="Dato for udflytning"
          [label]="'Dato for udflytning'"
          [required]="true"
          [max]="maxDate"
          >
        </dff-date-field>
      </div>
      @if (formGroup.get('erUdflytterMailSynlig').value) {
        <div>
          <mat-form-field>
            <input id="udflytterEmail" aria-label="E-Mail Adresse" matInput placeholder="Mailadresse" formControlName="mail" />
            @if (formGroup.get('mail').hasError('email')) {
              <mat-error> Mailadressen er ugyldig. </mat-error>
            }
          </mat-form-field>
        </div>
      }
    </div>
